module.exports = __webpack_public_path__ + "media/gallery-events.8b7049ea.webm";